/**
 * @fileoverview Agent definition for plot-planner-v1.
 *
 * Takes structural story output (storylines, beats, questions) from
 * storylines-planner-v1 and produces a detailed written plot narrative
 * in Markdown format.
 *
 * This is the "Plot Planner" in the split-planner pipeline:
 *   1. storylines-planner-v1 → structural output
 *   2. plot-planner-v1 → writtenPlot from structure (this agent)
 *   3. character-ideation-v2 → suggestedCharacters from structure
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-planner-v1',
  kind: 'primitive',
  name: 'Plot Planner',
  description: 'Takes storyline structure (storylines, beats, questions) and produces a detailed written plot narrative in Markdown. Downstream of storylines-planner-v1.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.plot',
    usedBy: ['use-long-story-planner.ts'],
    usedInWorkflows: ['story-planner-workflow-v1'],
    relatedAgents: ['storylines-planner-v1'],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-opus-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
